import { ReactNode } from "react";

import { FormattedMessage } from "react-intl";

import UFOSegment from "@atlassian/wac-ufo-segment";

import { Adg4CtaWithArrows } from "@/patterns/adg4/cta-with-arrows/cta-with-arrows";

export const FutureOfTeamwork = () => {
    return (
        <UFOSegment name="homepage-v2-futureOfTeamwork">
            <Adg4CtaWithArrows
                header={
                    <FormattedMessage
                        id="HomePageTemplateV2.futureOfTeamworkHeader"
                        defaultMessage="<helpUsShape>Help us shape</helpUsShape> <theFutureOfTeamwork>the future of teamwork</theFutureOfTeamwork>"
                        values={{
                            helpUsShape: (str: ReactNode) => (
                                <span className="h1 reduced-font-weight">
                                    {str}
                                </span>
                            ),
                            theFutureOfTeamwork: (str: ReactNode) => (
                                <span className="h1">{str}</span>
                            )
                        }}
                    />
                }
                paragraph={
                    <FormattedMessage
                        id="HomePageTemplateV2.futureOfTeamworkParagraph"
                        defaultMessage="At Atlassian, we believe the impossible is possible - together. Join us today to help us inspire teamwork anywhere and everywhere, worldwide."
                    />
                }
                ctaText={
                    <FormattedMessage
                        id="HomePageTemplateV2.futureOfTeamworkButton"
                        defaultMessage="Become an advocate"
                    />
                }
                ctaUrl="/careers"
            />
        </UFOSegment>
    );
};
